import { render, staticRenderFns } from "./UserPickerConfig.vue?vue&type=template&id=16946764&scoped=true"
import script from "./UserPickerConfig.vue?vue&type=script&lang=js"
export * from "./UserPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16946764",
  null
  
)

export default component.exports